// authenticationApi.ts
import { apiPaths, baseApi } from '@services';
import { transformAuth, transformUserData } from '../mappers';
import {
    AuthenticationsResponse,
    GetUserDataArgs,
    LoginQueryArgs,
    UserData,
} from '../types';

const extendedApi = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        login: builder.query<AuthenticationsResponse, LoginQueryArgs>({
            query: (args) => ({
                url: apiPaths.authentication.login(),
                method: 'POST',
                body: args,
            }),
            transformResponse: transformAuth,
            providesTags: () => ['Authentication'],

            async onQueryStarted(_, { dispatch, queryFulfilled }) {
                await queryFulfilled;
                dispatch(extendedApi.endpoints.getUserData.initiate());
            },
        }),

        logout: builder.mutation<void, void>({
            query: () => ({
                url: apiPaths.authentication.logout(),
            }),
            invalidatesTags: () => ['Authentication'],
        }),

        getUserData: builder.query<UserData, GetUserDataArgs>({
            query: () => ({
                url: apiPaths.data.getUserData(),
            }),
            transformResponse: transformUserData,
        }),
    }),
});

export const {
    useLoginQuery,
    useLazyLoginQuery,
    useLogoutMutation,
    useGetUserDataQuery,
} = extendedApi;

export default extendedApi.endpoints;
